import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import type { CrosswordPresence } from "./Player";
import { registerCrosswordTranslations } from "./i18n";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type {
  CrosswordDefinition,
  CrosswordProgress,
  CrosswordSolution,
  CrosswordSubmission,
} from "./types";

registerCrosswordTranslations(i18n);

export const crosswordModule: PuzzleTypeModule<
  CrosswordDefinition,
  CrosswordSubmission,
  CrosswordProgress,
  CrosswordSolution,
  CrosswordPresence
> = {
  key: "crossword",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  // No localFeedback: nothing about a letter can be checked without the solution (ADR 0032).
};
